import { trans } from "@mongez/localization";
import { createPortal } from "core/shared";
import { Button, Check } from "~/design-system/components";
import { Portal } from "~/modules/shared/components";

export const successPortal = createPortal("success-portal");

export function SuccessPortal() {
  return (
    <Portal portal={successPortal} width={500} closeButton={false}>
      <div className="font-playfair flex flex-col items-center gap-6">
        <div className="flex size-18 items-center justify-center rounded-full border border-black bg-[#E4B5BC] text-white">
          <Check className="size-10" />
        </div>

        <div className="flex flex-col items-center gap-2 text-center">
          <h2 className="text-lg font-semibold sm:text-xl lg:text-2xl">
            {trans("sendRequestDoneSuccessfully")}
          </h2>
          <p className="text-center text-base font-medium text-neutral-700">
            {trans("sendRequestDoneSuccessfullyDescription")}
          </p>
        </div>

        <Button
          onClick={successPortal.close}
          className="hover:bg-primary-300 mt-4 w-full justify-center gap-2 rounded-full border font-bold"
        >
          {trans("close")}
        </Button>
      </div>
    </Portal>
  );
}
